import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '50px 20px' }}>
      <h1>Page Not Found</h1>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <Link to="/" style={{ 
        display: 'inline-block', 
        marginTop: '20px',
        padding: '10px 20px',
        background: '#0056b3',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px'
      }}>
        Return to Home
      </Link>
    </div>
  );
}

export default NotFound;
